<template>
  <div>
    <a-modal width="100%" :visible.sync="approvalFormVisible" :confirmLoading="confirmLoading" @cancel="handleCancel"
      okText="提交" wrapClassName="ant-modal-cust-warp" :dialog-style="{ height: '100%', top: 0 }">
      <template slot="title">
        <div class="modal-title">
          <span class="back-icon" @click="handleCancel"><a-icon type="left" />&nbsp;返回</span>
          <label>{{ modalTitle }}</label>
          <label style="display: flex; align-items: center">OA流水号：
            <a @click="getSerialNumber" v-if="!submitForm.serialNumber">获取</a>
            <copy-text :copyVal="submitForm.serialNumber" v-else />
          </label>


        </div>
      </template>
      <div class="work-name">
        <span class="work-name-label">工作名称/文号：</span>
        <a-input :addon-before="formName" v-model="submitForm.formTitle" placeholder="请填写工作名称/文号"
          :class="{ 'has-error': !submitForm.formTitle }">
          <template slot="addonAfter" v-if="formTitleRuleConfig.type === 1">
            <a-icon v-if="formTitleLoading" type="loading" />
            <a-icon v-else type="loading-3-quarters" />
          </template>
        </a-input>
      </div>
      <a-row :gutter="16" class="scrollable-content">
        <a-col :span="showApprovalProcess ? 16 : 24">
        
          
          <!-- 附件列表展示 -->
          <div v-if="fileList && fileList.length" class="file-list-section"   v-loading="loading">
            <div class="file-list-title">附件列表</div>
            <div class="file-list-items">
              <div v-for="file in fileList" :key="file.id" class="file-item">
                <a-icon :type="getFileIcon(file.extension)" class="file-icon" />
                <span class="file-title" :title="file.title">{{ file.title }}</span>
                <span class="file-size">{{ formatFileSize(file.size) }}</span>
              </div>
            </div>
          </div>
          <form-render :key="formRenderKey" ref="form" :forms="forms" v-model="formData" />
        </a-col>
        <a-col v-if="showApprovalProcess" :span="8" class="sticky-content">
          <a-timeline v-if="process.length">
            <!-- 过滤条件分支 -->
            <a-timeline-item v-for="item in process.filter((v) => v.type !== 'CONDITIONS')" :key="item.id">
              <!-- 审批人 -->
              <template v-if="['ROOT', 'APPROVAL', 'CC'].includes(item.type)">
                <i v-if="item.type === 'ROOT'" class="el-icon-user-solid icon-timeline" slot="dot"></i>
                <i v-else-if="item.type === 'CC'" class="el-icon-s-promotion icon-timeline" slot="dot"></i>
                <i v-else class="el-icon-s-check icon-timeline" slot="dot"></i>
                <div class="timeline-warp" :data-id="item.id">
                  <div class="timeline-left">
                    <h3 style="margin-bottom: 0">
                      <span v-if="judgeRequired(item)" style="color: red">*</span>
                      {{ item.name }}
                    </h3>
                    <p v-if="item.type === 'ROOT'">发起本流程</p>
                    <p v-else-if="item.type === 'CC'">流程结果将会抄送他们</p>
                    <p v-else>
                      {{ item.props && approvalTypes[item.props.assignedType] }}
                      <span v-if="
                        item.props.assignedUser &&
                        item.props.assignedUser.length > 1
                      ">（{{ item.props.assignedUser.length }}人审批）<a-tag color="purple"
                          v-if="item.props && item.props.mode">{{ countersignModeMap[item.props.mode] }}</a-tag></span>
                      <a-tooltip
                        v-if="item.props.assignedType === 'ROLE' && item.props.role && item.props.role.length > 3"
                        placement="bottom" :title="getFullRoleNames(item.props.role)">
                        <a-tag color="blue" class="role-tag-with-tooltip">{{ formatRoleNames(item.props.role) }}</a-tag>
                      </a-tooltip>
                      <a-tag v-else-if="item.props.assignedType === 'ROLE'" color="blue">{{
                        formatRoleNames(item.props.role) }}</a-tag>
                      <a-tag color="cyan" v-if="item.props.hasCandidate">存在候选人列表
                      </a-tag>
                    </p>
                    <div class="special-info" v-if="showApproverSelect(item)">
                      审批人将由节点【<b>{{
                        approverSelectNodeName(item.props)
                        }}</b>】指派
                    </div>
                  </div>
                  <div class="timeline-right">
                    <!-- 指定人员 -->
                    <template v-if="
                      item.props.assignedUser &&
                      item.props.assignedUser.length &&
                      !['LEADER', 'LEADER_TOP'].includes(
                        item.props.assignedType
                      )
                    ">
                      <div class="avatar-box" v-for="org in item.props.assignedUser" :key="org.id">
                        <div :class="['avatar', org.type]">
                          <i v-if="org.type === 'dept'" class="iconfont icon-map-site"></i>
                          <span v-else>{{ getShortName(org.name) }}</span>
                        </div>
                        <div class="name" :title="org.name">{{ org.name }}</div>
                        <i v-if="showClosePicker(item)" class="close el-icon-close" @click="removeUser(item, org)"></i>
                      </div>
                    </template>
                    <!-- 角色 -->

                    <template v-if="showSelectUser(item)">
                      <div :class="[
                        'avatar-box',
                        showApproverSelect(item, 'root') ? 'disabled' : '',
                      ]">
                        <i class="el-icon-plus add-user" @click="handleAddUser(item)"></i>
                        <span class="name">添加</span>
                      </div>
                    </template>
                  </div>
                </div>
              </template>
              <!-- 条件分支 -->
              <template v-else>
                <i class="el-icon-share icon-timeline" slot="dot"></i>
                <div class="timeline-warp">
                  <div class="timeline-left">
                    <!-- 分支条件 -->
                    <a-radio-group v-model="selectedCondition" size="small" button-style="solid">
                      <a-radio-button v-for="con in item.branchs" :key="con.id" :value="con.id">
                        <span :class="[
                          'condition',
                          selectedCondition === con.id ? 'active' : '',
                        ]">{{ con.name }}</span>
                      </a-radio-button>
                    </a-radio-group>
                    <p>只执行第一个满足的条件</p>
                  </div>
                </div>
              </template>
            </a-timeline-item>
            <!-- 默认结束节点 -->
            <a-timeline-item>
              <i class="el-icon-success icon-timeline" slot="dot"></i>
              <div style="margin-left: 10px">结束</div>
            </a-timeline-item>
          </a-timeline>
          <a-empty v-else description="暂无审批流程"></a-empty>
        </a-col>
      </a-row>
      <template slot="footer">
        <a-button @click="handleCancel" icon="close">取消</a-button>
        <!-- <a-button type="primary" @click="handleOk(0)" :loading="confirmLoading" ghost icon="check-square">暂存</a-button> -->
        <a-button type="primary" @click="handleOk(1)" :loading="confirmLoading" icon="check">提交</a-button>
      </template>
    </a-modal>
    <!-- 用户选择组件 -->
    <org-picker :type="pickerType" :multiple="selfSelectMultiple" :selected="selectedUserList" ref="orgPicker"
      @ok="selectedUser" />

  </div>
</template>

<script>
import {
  flattenTree,
  splitPropsParams,
  processFormData, 
} from '@/components/approval/approvalUtil'
import CopyText from '@/components/CopyText'
 import * as u from '@/utils/util'
import * as c from '@/utils/config'
import OrgPicker from '@/components/OrgPicker'
import FormRender from '@/components/approval/common/form/FormRender'
 
export default {
  components: {
    FormRender,
    CopyText,
    OrgPicker

  },
  data() {
    return {
      modalTitle: '发起审批',
      approvalFormVisible: false,
      confirmLoading: false,
      formData: {},
      // 用于强制重新渲染表单（解决明细表内部状态未重置的问题）
      formRenderKey: 0,
      forms: [],
      process: [], // 审批流程定义
      submitForm: {},
      processId: null,
      selfSelectMultiple: false, // 自选审批人是否多选
      pickerType: 'user', // 用户选择组件类型
      selectedCondition: '', // 选中的条件
      nodePredicParams: {}, // 节点预测条件参数
      formId: null, // 表单id
      originalId: null, // 原始表单id
      draftList: [], // 草稿箱列表
      draftVisible: false,
      formName: '', // 表单名称
      nodepredictDetails: {}, // 节点预测条件详情
      conditionNodeBranchs: [], // 条件节点分支 默认第一个条件分支
      nextApprovalNode: [], // 后续审批节点
      conditionNodeChildren: [], // 条件节点子节点
      selectedUserList: [], // 已选用户
      formTitleRuleConfig: {}, // 表单标题规则配置
      formTitleLoading: false,
      commitFormType: 'initiate',
      showApprovalProcess: true,
      fullProcess: [], // 完整的流程节点
      filterOriginBizAlias: [],
      // 保存组件的原始权限，用于还原
      originalComponentPerms: new Map(), // key: component.id, value: original perm
      // 历史表单相关
      historyFormModalVisible: false,
      historyFormLoading: false,
      historyFormList: [],
      historyFormFilter: {
        formTitle: '',
        keyword: ''
      },
      historyFormPagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        showTotal: (total) => `共 ${total} 条`
      },
      selectedHistoryFormKeys: [],
      selectedHistoryForm: null,
      // 历史表单表格列定义
      historyFormColumns: [
        {
          title: '工作名称/文号',
          dataIndex: 'formTitle',
          key: 'formTitle',
          scopedSlots: { customRender: 'formTitle' }
        },
        // {
        //   title: "摘要信息",
        //   dataIndex: "summary",
        //   key: "summary",
        //   ellipsis: true,
        // },
        {
          title: 'OA流水号',
          dataIndex: 'serialNumber',
          key: 'serialNumber',
          width: 110
        },
        {
          title: '更新时间',
          dataIndex: 'updateTime',
          key: 'updateTime',
          scopedSlots: { customRender: 'updateTime' },
          width: 160
        }
      ],
      userInfoCache: u.getSession(c.sessionKey.USER_INFO),

      originalFormComponents: [], // 原始表单组件
      fileIds:[],
      fileList:[],
      DDAttachmentID:'',
      loading:false
    }
  },
  computed: {
    showApproverSelect() {
      return function (item, nodeId = '') {
        return (
          item.props &&
          item.props.approverSelect &&
          item.props.approverSelect.nodeId &&
          item.props.approverSelect.nodeId !== nodeId
        )
      }
    },
    approverSelectNodeName() {
      return function (item) {
        const nodeId =
          item && item.approverSelect && item.approverSelect.nodeId
        if (nodeId) {
          const node = this.process.find((v) => v.id === nodeId)
          return node && node.name
        }
        return ''
      }
    },
    countersignModeMap() {
      return {
        NEXT: '会签-依次',
        AND: '会签-同时',
        OR: '或签'
      }
    },
    showClosePicker() {
      return function (item) {
        if (!item.props) return
        if (item.type === 'CC') {
          return item.props.shouldAdd
        } else {
          return ['ROLE', 'SELF_SELECT'].includes(item.props.assignedType)
        }
      }
    },
    showSelectUser() {
      return function (item) {
        // 11-19：扩展角色自选、抄送人自选
        if (item.type === 'CC') {
          return item.props && item.props.shouldAdd
        } else {
          if (
            item.props &&
            ['ROLE', 'SELF_SELECT'].includes(item.props.assignedType)
          ) {
            if (item.props.selfSelect.multiple) {
              return true
            } else {
              return !item.props.assignedUser.length
            }
          }
        }
        return false
      }
    },
    approvalTypes() {
      return {
        ASSIGN_USER: '指定人员',
        SELF_SELECT: '自选审批人',
        LEADER_TOP: '连续多级主管',
        LEADER: '主管',
        ROLE: '角色自选',
        SELF: '发起人自己',
        FORM_USER: '表单内联系人'
      }
    },
    // 处理角色名称显示
    formatRoleNames() {
      return function (roles) {
        if (!roles || !Array.isArray(roles) || roles.length === 0) return ''

        const roleNames = roles.map(v => v.name)
        const maxDisplay = 3

        if (roleNames.length <= maxDisplay) {
          return roleNames.join(',')
        } else {
          const displayNames = roleNames.slice(0, maxDisplay)
          return `${displayNames.join(',')}...（共${roleNames.length}个角色）`
        }
      }
    },
    // 获取完整角色名称列表用于tooltip
    getFullRoleNames() {
      return function (roles) {
        if (!roles || !Array.isArray(roles)) return ''
        return roles.map(v => v.name).join(',')
      }
    }
  },
  mounted() {

  },
  methods: {
    // 获取文件图标
    getFileIcon(extension) {
      const iconMap = {
        'doc': 'file-word',
        'docx': 'file-word',
        'xls': 'file-excel',
        'xlsx': 'file-excel',
        'pdf': 'file-pdf',
        'ppt': 'file-ppt',
        'pptx': 'file-ppt',
        'txt': 'file-text',
        'zip': 'file-zip',
        'rar': 'file-zip',
        'jpg': 'file-image',
        'jpeg': 'file-image',
        'png': 'file-image',
        'gif': 'file-image',
        'vue': 'file-text',
        'js': 'file-text',
        'ts': 'file-text'
      }
      return iconMap[extension] || 'file'
    },
    // 格式化文件大小
    formatFileSize(bytes) {
      if (bytes === 0) return '0 B'
      const k = 1024
      const sizes = ['B', 'KB', 'MB', 'GB']
      const i = Math.floor(Math.log(bytes) / Math.log(k))
      return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i]
    },
    // 选择审批人
    selectedUser(data) {
      this.process.forEach((item) => {
        if (item.id === this.processId) {
          this.$set(item.props, 'assignedUser', data)
        }
      })
    },
    handleAddUser(item) {
      let ids = ''
      let candidateList = []
      this.selectedUserList = (item.props && item.props.assignedUser) || []
      if (item.type === 'CC') {
        this.selfSelectMultiple = true // 抄送人自选多选
        this.pickerType = 'user'
      } else {
        if (item.props && item.props.assignedType === 'ROLE') {
          this.pickerType = 'role'
          ids = item.props.role.map((v) => v.id).join()
        } else if (item.props && item.props.assignedType === 'SELF_SELECT') {
          this.pickerType = 'user'
          if (item.props.hasCandidate) {
            candidateList = item.props.candidateList
          } else {
            candidateList = []
          }
        } else {
          this.pickerType = 'user'
        }
        this.selfSelectMultiple = item.props.selfSelect.multiple // 自选审批人是否多选
      }
      this.processId = item.id
      this.$nextTick(() => {
        this.$refs.orgPicker.show(ids, candidateList)
      })
    },
    getShortName(name) {
      if (name) {
        return name.length > 2 ? name.substring(1, 3) : name
      }
      return '**'
    },
    // 判断是否必选审批人
    judgeRequired(item) {
      return (
        item.props &&
        ['SELF_SELECT', 'ROLE'].includes(item.props.assignedType) &&
        !(
          item.props.approverSelect &&
          item.props.approverSelect.nodeId &&
          item.props.approverSelect.nodeId !== 'root'
        )
      )
    },
    handleCancel() {
      this.approvalFormVisible = false
    },
    // 格式化数据
    formateValue(key) {
      try {
        // 1. 空值处理
        if (!this.formData || !key) {
          return ''
        }
        const value = this.formData[key]
        // 2. 非对象类型直接返回
        if (typeof value !== 'object' || value === null) {
          return value
        }

        // 3. 根据不同字段类型处理
        let resValue = []

        if (
          key.includes('InnerContactField') ||
          key.includes('DepartmentField')
        ) {
          // 联系人/部门字段
          resValue = Array.isArray(value)
            ? value.map((v) => v && v.name).filter(Boolean)
            : []
        } else if (
           key.includes('DDPhotoField')
        ) {
          // 附件/图片字段
          resValue = Array.isArray(value)
            ? value.map((v) => v && v.title).filter(Boolean)
            : []
        } else if (key.includes('OaProcessField')) {
          // OA流程字段
          resValue = Array.isArray(value)
            ? value.map((v) => v && v.serialNumber).filter(Boolean)
            : []
        } else if (
          key.includes('DDMultiSelectField') ||
          key.includes('DDDateRangeField') ||
          key.includes('StandardCircuitField')
        ) {
          // 多选/日期范围/标准电路字段
          resValue = Array.isArray(value) ? value : []
        } else if (key.includes('TableField')) {
          // 表格明细字段
          if (!Array.isArray(value) || value.length === 0) {
            return ''
          }

          // 使用递归查找函数，兼容明细表嵌套在分栏布局中的情况
          const tableField = this.findTableFieldRecursively(this.forms, key)

          if (!tableField) {
            console.warn('未找到对应的 TableField 组件:', key)
            return ''
          }

          const tableFieldId = tableField.id
          const tableFieldChildren = (tableField.props && tableField.props.children) || []
          const childIdSet = new Set(
            Array.isArray(tableFieldChildren) ? tableFieldChildren.map((child) => child.id) : []
          )

          resValue = value.map((item) => {
            if (!item || typeof item !== 'object') {
              return null
            }

            const normalizedRow = { ...item }

            // 按照 tableFieldChildren 的顺序构建 rowValue
            const rowValue = Array.isArray(tableFieldChildren) && tableFieldChildren.length
              ? tableFieldChildren.map((column) => {
                  const cellValue = normalizedRow[column.id]
                  return {
                    key: column.id,
                    value: cellValue && column.id.includes('StandardCircuitField')
                      ? (Array.isArray(cellValue) ? cellValue.join() : cellValue)
                      : (typeof cellValue === 'object' && cellValue !== null
                          ? JSON.stringify(cellValue)
                          : (cellValue !== undefined && cellValue !== null ? cellValue : '')),
                    label: column.title || (column.props && column.props.label),
                    bizAlias: column.bizAlias || (column.props && column.props.bizAlias) ||
                      (this.filterOriginBizAlias && this.filterOriginBizAlias.find((form) => form.id === column.id) && this.filterOriginBizAlias.find((form) => form.id === column.id).bizAlias)
                  }
                })
              : Object.keys(normalizedRow).map((rowKey) => ({
                  key: rowKey,
                  value: normalizedRow[rowKey] !== undefined && normalizedRow[rowKey] !== null
                    ? (typeof normalizedRow[rowKey] === 'object'
                        ? JSON.stringify(normalizedRow[rowKey])
                        : normalizedRow[rowKey])
                    : '',
                  label: (tableFieldChildren && tableFieldChildren.find((form) => form.id === rowKey) && tableFieldChildren.find((form) => form.id === rowKey).title),
                  bizAlias: (this.filterOriginBizAlias && this.filterOriginBizAlias.find((form) => form.id === rowKey) && this.filterOriginBizAlias.find((form) => form.id === rowKey).bizAlias)
                }))

            // 对于数据中存在但不在 tableFieldChildren 中的字段，追加到末尾
            if (tableFieldChildren.length) {
              Object.keys(normalizedRow).forEach((rowKey) => {
                if (!childIdSet.has(rowKey)) {
                  rowValue.push({
                    key: rowKey,
                    value: normalizedRow[rowKey] !== undefined && normalizedRow[rowKey] !== null
                      ? (typeof normalizedRow[rowKey] === 'object'
                          ? JSON.stringify(normalizedRow[rowKey])
                          : normalizedRow[rowKey])
                      : '',
                    label: (tableFieldChildren && tableFieldChildren.find((form) => form.id === rowKey) && tableFieldChildren.find((form) => form.id === rowKey).title),
                    bizAlias: (this.filterOriginBizAlias && this.filterOriginBizAlias.find((form) => form.id === rowKey) && this.filterOriginBizAlias.find((form) => form.id === rowKey).bizAlias)
                  })
                }
              })
            }

            return {
              rowNumber: `${tableFieldId}_${randomUUID()}`,
              rowValue
            }
          }).filter(Boolean) // 过滤掉 null 值
        } else if (key.includes('ParseFirmwareVersionForm')) {
          // 解析固件版本表单
          resValue = Array.isArray(value) ? value : []
        } else if (key.includes('SvnAssociatedFileField') || key.includes('SvnAssociatedFolderField')) {
          // SVN关联文件/文件夹字段
          const files = Array.isArray(value) ? value : []
          const rootSvnUrl = (files[0] && files[0].rootSvnUrl) || ''
          resValue = [rootSvnUrl]
        } else {
          // 其他对象类型
          resValue = Array.isArray(value) ? value : []
        }

        // 返回格式化后的值
        return key.includes('TableField') || key.includes('ParseFirmwareVersionForm')
          ? JSON.stringify(resValue)
          : (Array.isArray(resValue) ? resValue.join() : '')
      } catch (error) {
        console.error('Format value error:', error, 'key:', key)
        return ''
      }
    },
    open(record) {
       this.submitForm ={}
      this.fileIds = record ||[]
      this.loading = true
      this.$HttpService
        .post("/workflow/fileinfo/upload",{idList:record} )
        .then((res) => {
          this.loading = false
        this.fileList= res
         })
        .catch(() => {

        });
 
      //   this.commitFormType = "initiate";
      // this.formName = record.name
      this.formData = {}
      // 重置表单渲染组件，确保明细表等内部状态被清空重新初始化
      this.formRenderKey += 1
      // 清空原始权限缓存
      // this.originalComponentPerms.clear()
      this.approvalFormVisible = true
      this.confirmLoading = false
      // this.formTitleRuleConfig =
      //   (record.config && record.config.formTitleRuleConfig) || {}
      // this.originalFormComponents = record.formComponents // 保存原始表单组件
      // this.flatFormComponents(record) // 获取表单组件
      // this.filterOriginBizAlias = flattenAndFilterFields(this.forms)
      // this.formId = record.id

      this.$HttpService
        .post("/workflow/formdefinition/getbyid" )
        .then((res) => {

           this.modalTitle = `发起-【${res.name}】审批`
           this.formName = res.name
          let bpmn = res.processDefine && res.processDefine.bpmn
          this.process = (bpmn && flattenTree(JSON.parse(bpmn))) || []
           this.nodePredicParams.bpmn = bpmn
          this.renderFormNode()
          this.fullProcess = this.process // 保存完整的流程节点
          this.flatFormComponents(res) // 获取表单组件

        })
        .catch(() => {

        });

      // this.originalId = record.originalId || record.id
      // this.getDraftList()
      this.submitForm = {
        // formId: record.id,
        applyUsername: this.userInfoCache.username,
        state: 1
      }

      //   this.getApprovalnodeprediction();
    },

    flatFormComponents(record) {
      const mapChild = (child) => {
        // 过滤掉 DDAttachment 组件
        if (child.componentType === 'DDAttachment') {
          this.DDAttachmentID = child.props.componentId
          return null
        }
        return {
          ...splitPropsParams(child),
          props: {
            ...child.props,
            ...child.props.extendProps,
            options: ['DDSelectField', 'DDMultiSelectField'].includes(
              child.componentType
            )
              ? child.props.options && child.props.options.map((v) => v.value)
              : undefined,
            children: child.children ? child.children.map(mapChild).filter(Boolean) : []
          }
        }
      }

      this.forms = record.formComponents
        .filter(item => item.componentType !== 'DDAttachment') // 过滤掉顶层的 DDAttachment
        .map((item) => ({
          ...splitPropsParams(item),
          props: {
            ...item.props,
            ...item.props.extendProps,
            options: ['DDSelectField', 'DDMultiSelectField'].includes(
              item.componentType
            )
              ? item.props.options && item.props.options.map((v) => v.value)
              : undefined,
            children: item.children ? item.children.map(mapChild).filter(Boolean) : []
          }
        }))

     },

    handleOk(state) {
      let params = {
        ...this.submitForm,
        state,
        fileIds:this.fileIds,
        variables: {}
        // id: state ? this.submitForm.id : null, // 重新提交时传id、防止保存草稿误操作
      }
      if (!this.submitForm.formTitle && state) {
        this.$message.warn('请输入工作名称/文号！')
        return
      }

      this.filterOriginBizAlias.map((item) => {
        // if (this.formateValue(item.id)) {
        //   console.warn('this.formateValue(item.id)------', item.bizAlias, this.formateValue(item.id))
        // }
        params.variables[item.bizAlias] = this.formateValue(item.id) || ''
      })
      // console.warn('params.variables------', params.variables)
      // console.warn('this.filterOriginBizAlias------', this.filterOriginBizAlias)
      // return
      params.formTitle = this.formName + (params.formTitle || '')

      // 处理DocumentInformationForm数据
      const processedFormData = this.formData
      const fullComponents = processFormData(this.forms)
      params.formData = Object.keys(processedFormData)
        .filter((v) => v !== 'toBeUsedItemCodes')
        .map((key) => {
          const fieldValue = processedFormData[key]
          let textNoteValue = '' // 说明文字字段值
          const textNoteComponent = fullComponents.find((v) => v.id === key && v.name === 'TextNote')
          if (textNoteComponent) {
            textNoteValue = (textNoteComponent && textNoteComponent.props && textNoteComponent.props.placeholder) || ''
          }
          // 如果是DocumentInformationForm、SaleInformationForm或FunctionalTestingInformationForm的聚合数据，直接使用
          if (fieldValue && typeof fieldValue === 'object' && (fieldValue.id === 'DocumentInformationForm_groupForm' || fieldValue.id === 'SaleInformationForm_groupForm' || fieldValue.id === 'FunctionalTestingInformationForm_groupForm')) {
            return {
              id: key,
              value: fieldValue.value,
              extValue: fieldValue.extValue,
              bizAlias: fieldValue.bizAlias
            }
          }
          // 其他字段使用原来的逻辑
          return {
            id: key,
            value: textNoteValue || this.formateValue(key), // TODO:传入钉钉显示的值
            extValue:
              typeof fieldValue === 'object' &&
                fieldValue !== null
                ? JSON.stringify(fieldValue)
                : fieldValue, // TODO:为了页面回显
            bizAlias: (this.filterOriginBizAlias.find((v) => v.id === key) && this.filterOriginBizAlias.find((v) => v.id === key).bizAlias)
          }
        })

      this.process.map((item) => {
        const varUsers =
          (item.props &&
            item.props.assignedUser &&
            item.props.assignedUser.map((v) => v.username || v.id)) ||
          []
        const varUserFullNames =
          (item.props &&
            item.props.assignedUser &&
            item.props.assignedUser.map((v) => v.name)) ||
          []
        if (varUsers.length) {
          params.variables[`${item.id}_users`] = varUsers
        }
        if (varUserFullNames.length) {
          params.variables[`${item.id}_userFullNames`] = varUserFullNames
        }
      })

      const unselectedItems = this.process.filter(
        (v) =>
          this.judgeRequired(v) &&
          (!v.props.assignedUser || !v.props.assignedUser.length)
      )
      if (unselectedItems.length && state) {
        this.$message.warn('自选审批人不能为空！')
        this.addShakeEffect(unselectedItems)
      }
      // 为空处理
      if (!params.formData.length) {
        params.formData = this.forms.map((item) => {
          return {
            id: item.id,
            value: '',
            extValue: ''
          }
        })
      }
      
      // 添加附件信息到 formData
      if (this.fileList && this.fileList.length) {
        const attachmentValue = this.fileList.map(file => file.title).join(',')
        const attachmentExtValue = JSON.stringify(this.fileList.map(file => ({
          id: file.id,
          objectId: file.objectId,
          domain: file.domain,
          path: file.path,
          title: file.title,
          size: file.size,
          extension: file.extension
        })))
        
        params.formData.push({
          id: this.DDAttachmentID,
          value: attachmentValue,
          extValue: attachmentExtValue
        })
      }
      if (params.serialNumber) {
        // 提前获取流水号
        const draftItmes = this.draftList.find(
          (v) => v.serialNumber === params.serialNumber
        )
        if (draftItmes) {
          params.id = draftItmes.id // 直接使用草稿的id、避免重复的流水号
        }
      }
      //   console.warn("forms", this.forms);
      //   判断开发环境下
      //   if (process.env.NODE_ENV === "development") {
      //     return;
      //   }
      if (state) {
        this.$refs.form.validate((valid) => {
          // console.log('valid', valid ? '校验通过' : '校验失败')
          if (valid) {
            this.requestSubmitHandle(params, state)
          } else {
            this.confirmLoading = false
            this.$message.warning('请完善表单😥')
          }
        })
      } else {
        this.requestSubmitHandle(params, state)
      }
    },
        // 移除审批人
        removeUser(item, org) {
      let users = item.props.assignedUser.filter((user) => user.id !== org.id)
      this.$set(item.props, 'assignedUser', users)
    },
    requestSubmitHandle(params, state) {
       // console.warn("params------",params);
      // return
      this.confirmLoading = true
      this.$HttpService
        .post('/workflow/forminstance/submit', params)
        .then((res) => { 
          this.confirmLoading = false
          // if (res.code === 200) {
            this.$message.success('提交成功')
            this.$emit('ok')
            this.approvalFormVisible = false
          // }
        })
        .catch((err) => {
          this.confirmLoading = false
          console.error('requestSubmitHandle error:', err)
        })
    },
    // 渲染表单定义节点
    renderFormNode() {
      this.process = this.process.filter((item) => item.type !== 'TRIGGER') // 过滤掉触发器
      this.process.forEach((item) => {
        if (
          item.type === 'ROOT' ||
          (item.props && item.props.assignedType === 'SELF')
        ) {
          this.$set(item.props, 'assignedUser', [
            {
              name: this.userInfoCache.name,
              username: this.userInfoCache.username,
              id: this.userInfoCache.id
            }
          ])
        }
        // 针对自选审批人标识是否有候选人名单
        if (
          item.props &&
          item.props.assignedType === 'SELF_SELECT' &&
          item.props.assignedUser &&
          item.props.assignedUser.length
        ) {
          this.$set(item.props, 'hasCandidate', true)
          this.$set(item.props, 'candidateList', item.props.assignedUser) // 保存候选人名单
          this.$set(item.props, 'assignedUser', []) // 清空已选审批人
        } else {
          this.$set(item.props, 'hasCandidate', false)
        }
      })
      const rootNodeProcess = this.process.find((v) => v.id === 'root')
      if (rootNodeProcess) {
        let formPerms =
          (rootNodeProcess.props && rootNodeProcess.props.formPerms) || []
        if (this.forms.length) {
          this.forms.forEach((item) => {
            const formPermsItem = formPerms && formPerms.find((v) => v.id === item.id)
            // 保存原始权限
            if (!this.originalComponentPerms.has(item.id)) {
              this.originalComponentPerms.set(
                item.id,
                formPermsItem ? formPermsItem.perm : ''
              )
            }
            if (formPermsItem) {
              this.$set(item, 'perm', formPermsItem.perm)
            } else {
              this.$set(item, 'perm', '')
            }
            if (
              (['SpanLayoutField', 'OrderReviewForm', 'ProjectInfoForm', 'ProjectCostDataForm', 'StructuralInformationForm', 'SaleInformationForm'].includes(item.name)) &&
              item.props.children &&
              item.props.children.length
            ) {
              item.props.children.forEach((child) => {
                const formPermsChildItem = formPerms && formPerms.find(
                  (v) => v.id === child.id
                )
                // 保存原始权限
                if (!this.originalComponentPerms.has(child.id)) {
                  this.originalComponentPerms.set(
                    child.id,
                    item.perm === 'R' ? 'R' : (formPermsChildItem ? formPermsChildItem.perm : '')
                  )
                }
                if (formPermsChildItem) {
                  this.$set(child, 'perm', item.perm === 'R' ? 'R' : formPermsChildItem.perm)
                } else {
                  this.$set(child, 'perm', item.perm === 'R' ? 'R' : '')
                }
              })
            }
          })
        }
      }
    },
    getSerialNumber() {
      this.$HttpService
        .post('/workflow/formdefinition/genserialnumber' ).then((res) => {
          this.$set(this.submitForm, 'serialNumber', res)
        })
    },
  }

}
</script>

<style lang="less" scoped>
::v-deep .ant-timeline {
  padding-top: 10px !important;
}

.scrollable-content {
  position: relative;
  min-height: 800px;
  max-height: calc(100vh - 182px);
  overflow-y: auto;

  &::after {
    content: "";
    position: fixed;
    bottom: 53px;
    left: 0;
    width: 100%;
    height: 50px;
    background-image: -webkit-linear-gradient(bottom,
        #f2f5ff 20%,
        rgba(242, 245, 255, 0));
  }
}

.sticky-content {
  position: sticky;
  top: 0;
  max-height: calc(100vh - 182px);
  overflow-y: auto;
}

.icon-timeline {
  font-size: 18px;
  color: #ffffff;
  width: 24px;
  height: 24px;
  line-height: 24px;
  border-radius: 50%;
  background: #e4e7ed;
}

.timeline-warp {
  display: flex;
  justify-content: space-between;
  margin-left: 10px;

  .timeline-left {
    &>p {
      margin-bottom: 0;
    }

    .condition {
      text-decoration: line-through;
    }

    .active {
      text-decoration: none;
    }
  }

  .special-info {
    color: #ff7d00;
  }

  .timeline-right {
    display: flex;
    justify-content: flex-end;
    flex-wrap: wrap;
    max-width: 276px;
  }

  &.shake {
    animation: shake 0.5s;
  }
}

@keyframes shake {

  0%,
  100% {
    transform: translateX(0);
  }

  20%,
  60% {
    transform: translateX(-10px);
  }

  40%,
  80% {
    transform: translateX(10px);
  }
}

.avatar-box {
  display: flex;
  align-items: center;
  flex-direction: column;
  position: relative;

  &.disabled {
    cursor: not-allowed !important;
    pointer-events: none !important;
    color: rgba(0, 0, 0, 0.25) !important;

    .add-user {
      color: rgba(0, 0, 0, 0.25) !important;
      border: 1px solid #d9d9d9 !important;
      background-color: #f5f5f5 !important;
    }
  }

  .add-user {
    padding: 8px;
    font-size: 18px;
    border-radius: 50%;
    border: 1px dashed #8c8c8c;
    color: #333;
    cursor: pointer;

    &:hover {
      border-color: #1890ff;
      color: #1890ff;
    }
  }

  .name {
    width: 46px;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .close {
    position: absolute;
    top: 0;
    right: 0;
    color: #fff;
    cursor: pointer;
    border-radius: 50%;
    background: #000;
  }

  .avatar {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 35px;
    height: 35px;
    background: #1890ff;
    color: white;
    border-radius: 50%;

    &.dept {
      background: #f77234;
    }
  }
}

.role-name {
  width: 78px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.modal-title {
  display: flex;
  align-items: center;
  gap: 16px;

  .back-icon {
    cursor: pointer;
    font-size: 14px;
    color: #606266;
  }

  .draft-box {
    margin-left: auto;
    margin-right: 30px;
    color: #f78f5f;
  }
}

// 文件列表样式
.file-list-section {
  margin-top: 16px;
  padding: 16px;
  background: #fafafa;
  border-radius: 4px;
  border: 1px solid #e8e8e8;

  .file-list-title {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 12px;
    color: #262626;
  }

  .file-list-items {
    display: flex;
    flex-direction: column;
    gap: 8px;

    .file-item {
      display: flex;
      align-items: center;
      padding: 10px 12px;
      background: #fff;
      border-radius: 4px;
      border: 1px solid #e8e8e8;
      transition: all 0.3s;

      &:hover {
        border-color: #1890ff;
        box-shadow: 0 2px 8px rgba(24, 144, 255, 0.1);
      }

      .file-icon {
        font-size: 20px;
        margin-right: 12px;
        color: #1890ff;
      }

      .file-title {
        flex: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        color: #262626;
        font-size: 14px;
      }

      .file-size {
        margin-left: 12px;
        color: #8c8c8c;
        font-size: 12px;
        white-space: nowrap;
      }
    }
  }
}

.draft-list {
  background: #fff;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  padding: 16px;

  .draft-list-ul {
    margin: 0;
    padding: 0;
    display: flex;
    gap: 6px;
    flex-direction: column;
    width: 280px;

    .draft-item {
      background: #f5f7fa;
      padding: 6px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .draft-btn {
        &>a:first-child {
          color: red;
        }
      }
    }
  }
}

.work-name {
  display: flex;
  align-items: center;
  white-space: nowrap;
  margin-bottom: 8px;

  .work-name-label {
    font-weight: bold;
    font-size: 18px;

    &::before {
      content: "*";
      color: red;
      margin-right: 4px;
    }
  }
}

::v-deep .ant-modal-body {
  padding: 16px 24px !important;
}

/* 角色标签悬停提示样式 */
.role-tag-with-tooltip {
  cursor: help;
  position: relative;
}

.role-tag-with-tooltip:hover {
  border-color: #1890ff;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
}

.form-title {
  width: 100%;
  white-space: normal;
  word-break: break-all; //任意字符间段行：兼容中英数字符号混合换行
  overflow-wrap: break-word;
  line-height: 1.1;
}
</style>
